export default [
  { from: '/pension-documents', to: '/documents' },
  { from: '/add-money-to-your-pension', to: '/setup-contribution' },
];
